<template>
	<div class="rewards-preview">
    <loading-state :state="state"></loading-state>
    <div class="rewards-main" v-if="state.isLoaded()">
      <h2>{{lrewards.name}}</h2>
      <p>{{lrewards.desc}}</p>
      <div class="rewards-content">
        <ul v-if="lrewards.kind.isMedalByRank" class="items medal-by-rank">
          <li
          v-for="(medal, i) in lrewards.rank_medals"
          :key="i"
          >
            <b>{{medal}}</b>
            <span class="line" :class="medal"></span>
            <span>
              <span class="silent">Rank upto </span>
              {{lrewards.rank_break_points[i]}}
            </span>
          </li>
        </ul>
        <ul v-else-if="lrewards.kind.isChipsByRank" class="items">
          <li
          v-for="(chips, i) in lrewards.rank_chips"
          :key="i"
          >
            <b>{{chips}}$</b>
            <span class="line chips"></span>
            <span>
              <span class="silent">Rank upto </span>
              {{lrewards.rank_break_points[i]}}
            </span>
          </li>
        </ul>
        <div v-else-if="lrewards.kind.isChipsByPoint">
          {{lrewards.chips_per_point}}$ per point <br>
          Maximum of {{lrewards.max_chips}}$ <br>
          <span v-if="lrewards.default_participants_chips > 0">
            {{lrewards.default_participants_chips}}$ default price 
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { FantasyReward } from '@/models/fantasy'

export default {
  props: {
    rewards: {
      type: Object,
      defult: null
    },
    contestKey: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      lrewards: null,
      state: DataState.newNotInit()
    }
  },

  mounted () {
    this.onViewOpenned()
  },

  methods: {
    onViewOpenned () {
      if (this.rewards) {
        this.lrewards = this.rewards
        this.state.changeToLoaded()
        return
      }

      this.state.changeToLoading()
      FantasyReward.fetch(this.contestKey).then((resp) => {
        this.lrewards = resp
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
  }
}
</script>
